import { MoreOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import type { ModelProductLimit } from '@app/api/Products';

import type { MenuProps } from 'antd';
import type { ColumnsType } from 'antd/es/table';

const STOCK_CONTROL_MENU: NonNullable<MenuProps['items']> = [
  {
    key: 'stock-control',
    label: 'Контроль остатков',
    icon: <SettingOutlined />,
  },
];

export const getPurchasePlanningSettingsColumns = ({
  onStockControl,
}: {
  onStockControl: (record: ModelProductLimit) => void;
}): ColumnsType<ModelProductLimit> => [
  {
    title: 'Название',
    dataIndex: 'Name',
    key: 'Name',
    width: 180,
    ellipsis: true,
    render: (name: string | null | undefined) => (
      <span className="no-wrap-text" style={{ maxWidth: 300 }}>
        {name}
      </span>
    ),
  },
  {
    title: 'Категория товара',
    dataIndex: 'Category',
    key: 'Category',
    width: 180,
    ellipsis: true,
    render: (name: string | null | undefined) => (
      <span className="no-wrap-text" style={{ maxWidth: 300 }}>
        {name}
      </span>
    ),
  },
  {
    title: 'Желаемый остаток',
    dataIndex: 'DesiredLeftover',
    key: 'DesiredLeftover',
    width: 150,
    render: (value: number | null | undefined) => value ?? '—',
  },
  {
    title: 'Критический остаток',
    dataIndex: 'CriticalLeftover',
    key: 'CriticalLeftover',
    width: 150,
    render: (value: number | null | undefined) => value ?? '—',
  },
  {
    title: null,
    key: 'actions',
    dataIndex: 'actions',
    width: 48,
    fixed: 'right',
    render: (_: unknown, record: ModelProductLimit) => (
      <Dropdown
        placement="bottomLeft"
        menu={{
          items: STOCK_CONTROL_MENU,
          onClick: ({ key }) => {
            if (key === 'stock-control') {
              onStockControl(record);
            }
          },
        }}
      >
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    ),
  },
];
